import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

// Line-by-line masked reveal. Pass `lines` as an array of strings/nodes.
// trigger="load" animates on mount (hero); trigger="view" animates on scroll.
export const MaskText = ({
  lines = [],
  className = "",
  lineClassName = "",
  delay = 0,
  stagger = 0.09,
  duration = 0.9,
  trigger = "view",
}) => {
  const animProps =
    trigger === "load"
      ? { animate: { y: "0%" } }
      : { whileInView: { y: "0%" }, viewport: { once: true, margin: "-12% 0px" } };

  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em]">
          <motion.span
            className={`block ${lineClassName}`}
            initial={{ y: "115%" }}
            {...animProps}
            transition={{ duration, delay: delay + i * stagger, ease: EASE }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
};
